/**
 * 通用接口
 */
import request from './request'

/**
 * 上传图片文件
 * @param {File} file - 图片文件对象
 */
export function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/common/uploadFile/picFileWithWatermark', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
